import todosTypes from "./todos.types";

export default {
  [todosTypes.FETCH_TODOS_SUCCESS](state, payload) {
    state.type = todosTypes.FETCH_TODOS_SUCCESS;
    state.data = payload.data ;
  },
  [todosTypes.FETCH_TODOS_FAILED](state, payload) {
    state.type = todosTypes.FETCH_TODOS_FAILED;
    state.error = payload.error;
  },
  [todosTypes.FETCH_TODOS_REQUEST](state) {
    state.type = todosTypes.FETCH_TODOS_REQUEST;
  },
  [todosTypes.ADD_TODOS_SUCCESS](state, payload) {
    state.type = todosTypes.ADD_TODOS_SUCCESS;
    state.add = payload.data ;
  },
  [todosTypes.ADD_TODOS_FAILED](state, payload) {
    state.type = todosTypes.ADD_TODOS_FAILED;
    state.error = payload.error;
  },
  [todosTypes.ADD_TODOS_REQUEST](state) {
    state.type = todosTypes.ADD_TODOS_REQUEST;
  },
  [todosTypes.DELETE_TODOS_SUCCESS](state, payload) {
    state.type = todosTypes.DELETE_TODOS_SUCCESS;
    state.deleted = payload.deleted;
  },
  [todosTypes.DELETE_TODOS_FAILED](state, payload) {
    state.type = todosTypes.DELETE_TODOS_FAILED;
    state.error = payload.error;
  },
  [todosTypes.DELETE_TODOS_REQUEST](state) {
    state.type = todosTypes.DELETE_TODOS_REQUEST;
  },
  [todosTypes.UPDATE_TODOS_SUCCESS](state, payload) {
    state.type = todosTypes.UPDATE_TODOS_SUCCESS;
    state.update = payload.data;
  },
  [todosTypes.UPDATE_TODOS_FAILED](state, payload) {
    state.type = todosTypes.UPDATE_TODOS_FAILED;
    state.error = payload.error;
  },
  [todosTypes.UPDATE_TODOS_REQUEST](state) {
    state.type = todosTypes.UPDATE_TODOS_REQUEST;
  }
};
